export default class Errors {
  static REQUEST_ERROR = "requestError";

  static SESSION_EXPIRED = "sessionExpired";

  static TOO_MANY_ERRORS = "tooManyErrors";

  static CRITICAL_DATA_NOT_LOADED = "criticalDataNotLoaded";

  static DOCUMENT_LINE_ITEMS_AMOUNT_MISMATCH = "documentLineItemsAmountMismatch";
}
